NtechApp.ModalForm = function(useCache) {
    var me = this;
    me._useCache = useCache || false;
    me._useCacheCb = false;

    me._disableLoaders = false;

    me._ajax = new NtechApp.Ajax();
    me._loader = new NtechApp.Loader();
    me._overlay = new NtechApp.Overlay();

    me._sizesResolver = new NtechApp.SizesResolver();
    me._click = new NtechApp.TouchClickEvent();

    me._scrollLockers = [];
    me._showTimeout = null;
    me._hideTimeout = null;

    me._$form = null;

    return this;
};

NtechApp.ModalForm.CACHE = true;
NtechApp.ModalForm.OPEN_ANIMATION_START = "NtechApp.ModalForm.OpenAnimationStart";
NtechApp.ModalForm.OPEN_ANIMATION_END = "NtechApp.ModalForm.OpenAnimationEnd";

NtechApp.proto(NtechApp.ModalForm, {
    setFormView: function($form) {
        this._$form = $form;
        this._useCacheCb = true;
    },

    getFormView: function() {
        return this._$form;
    },

    disableLoaders: function() {
        this._disableLoaders = true;
    },

    getOverlay: function() {
        return this._overlay;
    },

    forceCacheCallback: function() {
        this._useCacheCb = true;
    },

    _enableLoader: function() {
        if(this._disableLoaders)
            return;

        this._loader.on();
        this._overlay.on();
    },

    _disableLoader: function() {
        if(this._disableLoaders)
            return;

        this._loader.off();
        this._overlay.off();
    },

    load: function(routeName, routeParams, cb) {
        var me = this;

        if(typeof routeParams == "function") {
            cb = routeParams;
            routeParams = {};
        }

        if(this._useCache && this._$form != null) {
            this._overlay.on();
            this._showForm((this._useCacheCb) ? cb : null);

            this._useCacheCb = false;
            return;
        }

        this._enableLoader();
        this._ajax.get({
            url: Routing.generate(routeName, routeParams),
            onSuccess: function(data) {
                me._$form = $($.parseHTML($.trim(data.formHtml)));
                $("body").append(me._$form);

                me._showForm(cb);
                me._loader.off();
            }
        });
    },

    _showForm: function(cb) {
        var me = this;

        me._$form.css("display", "block");
        this._sizesResolver.flushComputedStyles(me._$form);

        $(me).trigger(NtechApp.ModalForm.OPEN_ANIMATION_START);

        clearTimeout(me._hideTimeout);
        me._$form.addClass("visible");

        me._showTimeout = setTimeout(function() {
            $("body").addClass("modalFormOpen");
            if($("html").hasClass("touch"))
                $("body").addClass("modalFormOpenOnTouchDevice");

            if(typeof cb == "function")
                cb(me._$form);

            $(me).trigger(NtechApp.ModalForm.OPEN_ANIMATION_END);
        }, 400);

        // Closing side nav
        //$(window).trigger(NtechApp.SideNav.EVENT_FORCE_SIDENAV_CLOSE);

        if((this._useCache && this._scrollLockers.length == 0) || (!this._useCache))
            me._lockFormScroll.call(me);
    },

    _lockFormScroll: function() { 
        var $scrollableFormContent = this._$form.find(".scrollableFormContent");
        var me = this;

        $.each($scrollableFormContent, function() {
            me._scrollLockers.push(NtechApp.lockScroll($(this)));
        });
    },

    unload: function() {
        var me = this;
        clearTimeout(this._showTimeout);

        this._hideTimeout = setTimeout(function() {
            $("body").removeClass("modalFormOpen");
            $("body").removeClass("modalFormOpenOnTouchDevice");

            me._$form.css("display", "none");
        }, 400);

        me._disableLoader();
        me._$form.removeClass("visible");

        if(this._useCache && this._$form != null)
            return;

        this.destroy();
    },

    destroy: function() {
        var me = this;

        for(var i = 0; i < this._scrollLockers.length; i++)
            this._scrollLockers[i].destroy();

        setTimeout(function() {
            me._$form.remove();
            me._$form = null;
        }, 400);
    }
});